import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import BgImg from "../../images/services-usa/app-store-optimization/banner.webp";

function Banner(props) {
  return (
    <div
      className="service_usa web_dev_service on_demand_banner cloud_cost_banner"
      style={{
        backgroundImage: `url(${BgImg})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={8} lg={7} xl={6} xxl={6} className="my-auto">
            <div className="banenr_content">
              <h1 className="web_head_banner" style={{ marginBottom: "10px" }}>
                App Store Optimization Services
              </h1>
              <span>Rank Higher, Grow Faster</span>
              <p style={{ marginTop: "10px" }}>Turn app searches into downloads with targeted ASO services. From app store dominance to expansive user acquisition, we help technopreneurs and enterprises overcome modern app growth challenges. Our full-cycle app store optimization agency offers launch readiness, boosts the impression-to-download ratio, and enables lifetime value (LTV) growth.</p>
              <Link
                to="/contact"
                className="border_btn"
                aria-label="TekRevol Contact"
              >
                Grow App Story Visibility
              </Link>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Banner;
